import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import hearaboutService from "../services/hearaboutService";
import "../assets/hearabout.css";
import Loader from "../components/Loader";

const HearAbout = () => {
  const [hearAbouts, setHearAbouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiFailed, setApiFailed] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  useEffect(() => {
    loadHearAbouts();
  }, []);

  const loadHearAbouts = async () => {
    try {
      setLoading(true);
      setApiFailed(false);

      const data = await hearaboutService.getAll();
      setHearAbouts(data);
    } catch (err) {
      console.error("Error loading hear abouts:", err);
      setApiFailed(true);

      // Fallback to mock data when API fails
      const mockData = [
        { id: 1, name: "Friend/Family Recommendation" },
        { id: 2, name: "Google Search" },
        { id: 3, name: "Job Board" },
        { id: 4, name: "Other" },
        { id: 5, name: "Professional Network" },
        { id: 6, name: "Property Website" },
        { id: 7, name: "Social Media" },
        { id: 8, name: "University/College" },
      ];

      setHearAbouts(mockData);
      toast.warning("Using mock data - API connection failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setFormData({ name: "" });
    setShowCreateModal(true);
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this hear about option?")
    ) {
      try {
        if (apiFailed) {
          // Mock delete when API is down
          setHearAbouts((prev) => prev.filter((item) => item.id !== id));
          toast.success("Hear about option deleted successfully (mock mode)");
        } else {
          await hearaboutService.delete(id);
          setHearAbouts((prev) => prev.filter((item) => item.id !== id));
          toast.success("Hear about option deleted successfully");
        }
      } catch (err) {
        console.error("Error deleting hear about:", err);
        toast.error("Failed to delete hear about option");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Name is required");
      return;
    }

    try {
      setSubmitting(true);

      if (apiFailed) {
        // Mock create when API is down
        const newItem = {
          id: Date.now(),
          name: formData.name.trim(),
        };
        setHearAbouts((prev) => [...prev, newItem]);
        setShowCreateModal(false);
        setFormData({ name: "" });
        toast.success("Hear about option created successfully (mock mode)");
      } else {
        const newItem = await hearaboutService.create({
          name: formData.name.trim(),
        });
        setHearAbouts((prev) => [...prev, newItem]);
        setShowCreateModal(false);
        setFormData({ name: "" });
        toast.success("Hear about option created successfully");
      }
    } catch (err) {
      console.error("Error saving hear about:", err);
      toast.error(err.message || "Failed to save hear about option");
    } finally {
      setSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  if (loading) return <Loader />;
  if (error) return <div className="error-container">Error: {error}</div>;

  console.log("Rendering HearAbout component, hearAbouts:", hearAbouts.length);

  return (
    <div className="hear-about-container">
      {/* API Status Warning */}
      {apiFailed && (
        <div className="api-warning">
          <div className="warning-content">
            <span className="warning-icon">⚠️</span>
            <span className="warning-text">
              API connection failed. Using mock data.
            </span>
          </div>
        </div>
      )}

      {/* Breadcrumbs */}
      {/* <div className="breadcrumb-section"> */}
      {/* <div className="breadcrumb-hear-about">
          <a href="/dashboard">Dashboard</a> /{" "}
          <a href="/guardians">Guardians</a> /{" "}
          <span className="current-page">Hear About</span>
        </div> */}
      {/* </div> */}

      {/* Main Content */}
      <div className="main-content" style={{maxWidth: 1088}}>
        {/* Test Element */}
        {/* <div
          style={{
            background: "yellow",
            padding: "10px",
            marginBottom: "20px",
          }}
        >
          <strong>
            DEBUG: HearAbout component is rendering. Button should be visible
            below.
          </strong>
        </div> */}

        {/* Breadcrumbs */}
        {/* <div className="breadcrumb-section"> */}
        <div className="breadcrumb-hear-about">
          <a href="/dashboard">Dashboard</a> /{" "}
          <a href="/guardians">Guardians</a> /{" "}
          <span className="current-page">Hear About</span>
        </div>
        {/* </div> */}

        {/* Header */}
        <div
          className="page-header-hear-about"
          style={{ minHeight: "80px", border: 'none' }}
        >
          <h1 className="page-title">Hear About</h1>
          <div style={{ padding: "10px" }}>
            <button
              className="add-button"
              onClick={handleCreate}
              type="button"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                // backgroundColor: "#007bff",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                padding: "12px 20px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                minWidth: "140px",
                justifyContent: "center",
              }}
            >
              <span className="plus-icon">+</span>
              <span className="button-text">Add Hear About</span>
            </button>
          </div>
        </div>

        {/* Data List */}
        <div className="data-list">
          <div className="list-header">
            <div className="name-column">Name</div>
            <div className="action-column">Action</div>
          </div>
          <div className="list-items">
            {hearAbouts.map((hearAbout) => (
              <div
                key={hearAbout.id}
                className="list-item"
                style={{ backgroundColor: "white", marginBottom: 8 }}
              >
                <div className="name-column">{hearAbout.name}</div>
                <div className="action-column">
                  <button
                    className="delete-button"
                    onClick={() => handleDelete(hearAbout.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Create Modal */}
      {showCreateModal && (
        <div className="modal-overlay">
          <div className="main-content-hear-about">
            <div className="modal-header-teal">
              <h3>Add hear about</h3>
              <button
                className="close-button-white"
                onClick={() => setShowCreateModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body-white" style={{width: 852}}>
              <div className="form-row" style={{padding: 45}}>
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter hear about option name"
                  required
                />
                <button
                  type="button"
                  className="save-button-inline"
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
            <div className="modal-footer-teal" style={{justifyContent: 'flex-end'}}>
              <button
                type="button"
                className="close-button-red"
                onClick={() => setShowCreateModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HearAbout;
